import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Avatar,
  Box,
  Container,
  Grid,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import Helper from "../../common/Helper";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCard from "../home/DashboardCard";

export default function CombineResultShootingDrills(props) {
  let navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "5px 15px",
      border: "1px solid lightgrey",
      borderRadius: "10px",
      boxShadow: "2px 2px 11px grey inset",
    },
    listItemIcon: {
      minWidth: "38px",
    },
    imageIcon: {
      width: "100%",
      height: "100%",
      cursor: "pointer",
    },
    iconRoot: {
      textAlign: "center",
      width: "100%",
      height: "50px",
    },
    cardStyle: {
      border: "1px solid lightgrey",
      borderRadius: "10px",
      height: "250px",
    },
    headerText: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerText2: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerTextInfo: {
      color: "rgb(29, 66, 138)",
      fontSize: "14px",
    },
    headerBox: {
      background: "#c1d0ed",
      borderRadius: "17px",
    },
    smBlue: {
      marginLeft: "16px",
      width: 26,
      height: 26,
      color: theme.palette.getContrastText("#0c2c75"),
      backgroundColor: "#1e3f7e",
      position: "relative",
      borderRadius: "50%",
    },
    stickyColumn: {
      position: "sticky",
      background: "white",
      left: 0,
      zIndex: 1,
      paddingRight: theme.spacing(1),
    },
    playerNameStyle: {
      fontSize: "12px",
      cursor: "pointer",
      "&:hover": {
        color: "blue",
      },
    },
    cellValue: {
      padding: "4px",
      fontSize: "12px",
    },
  }));
  const classes = useStyles();
  const {
    favPlayersShootingDrillData,
    playerShootingDrillsColumns,
    favPlayersShootingDrillDataselected,
    Showval,
    notes,
    loading,
    spotUp,
    sideMidSide,
    midSideMid,
    offTheDribble,
    freeThrows,
    point3Star,
    midRangeStar,
    eventId,
    selectedTab,
    isWebView,
  } = props;

  const [shootingDrillsOrder, setShootingDrillsOrder] = React.useState("asc");

  const [shootingDrillsOrderBy, setShootingDrillsOrderBy] =
    React.useState("playerName");

  const tab3Ref = useRef();

  useEffect(() => {
    if (selectedTab === 2) {
      tab3Ref.current.addEventListener("touchstart", isolateTouch, {
        passive: true,
      });
      tab3Ref.current.addEventListener("touchmove", isolateTouch, {
        passive: true,
      });
      tab3Ref.current.addEventListener("touchend", isolateTouch, {
        passive: true,
      });
    }

    return () => {
      if (tab3Ref.current) {
        tab3Ref.current.removeEventListener("touchstart", isolateTouch, {
          passive: true,
        });
        tab3Ref.current.removeEventListener("touchmove", isolateTouch, {
          passive: true,
        });
        tab3Ref.current.removeEventListener("touchend", isolateTouch, {
          passive: true,
        });
      }
    };
  }, [selectedTab]);

  const isolateTouch = (e) => {
    e.stopPropagation();
  };

  const handleShootingDrillsSortRequest = (e, property) => {
    const isAsc =
      shootingDrillsOrderBy === property && shootingDrillsOrder === "asc";
    setShootingDrillsOrder(isAsc ? "desc" : "asc");
    setShootingDrillsOrderBy(property);
  };
  function getComparator(sortOrder, sortOrderBy) {
    return (a, b) => descendingComparator(a, b, sortOrder, sortOrderBy);
  }
  function descendingComparator(a, b, sortOrder, sortOrderBy) {
    if (a[sortOrderBy] === b[sortOrderBy]) {
      return 0;
    } else if (sortOrder === "asc") {
      return a[sortOrderBy] < b[sortOrderBy] ? -1 : 1;
    } else {
      return a[sortOrderBy] < b[sortOrderBy] ? 1 : -1;
    }
  }

  const viewPlayerProfile = (playerId, playerName) => {
    if (isWebView) {
      return sendNavigation("PLAYER_DETAILS", { UserName: playerName });
    }

    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CombineResults", tab: 2 },
    });
  };

  const sendNavigation = (screenName, params) => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ action: "NAVIGATE", screen: screenName, params })
    );
  };

  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Shooting Drills
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer ref={tab3Ref}>
              {favPlayersShootingDrillData &&
                favPlayersShootingDrillData.length > 0 && (
                  <Table>
                    <TableHead>
                      {playerShootingDrillsColumns.map((elem, i) => {
                        return (
                          <TableCell
                            className={
                              elem.id === "playerName"
                                ? classes.stickyColumn
                                : classes.na
                            }
                            sx={{
                              padding: "4px",
                              paddingLeft:
                                elem.id === "playerName" ? "25px" : "0px",
                              fontSize: "12px",
                            }}
                          >
                            <TableSortLabel
                              active={shootingDrillsOrderBy === elem.id}
                              direction={
                                shootingDrillsOrderBy === elem.id
                                  ? shootingDrillsOrder
                                  : "asc"
                              }
                              onClick={(e) =>
                                handleShootingDrillsSortRequest(e, elem.id)
                              }
                            >
                              {elem.headerName}
                              {shootingDrillsOrderBy === elem.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                  {shootingDrillsOrder === "desc"
                                    ? "sorted descending"
                                    : "sorted ascending"}
                                </Box>
                              ) : null}
                            </TableSortLabel>
                          </TableCell>
                        );
                      })}
                    </TableHead>
                    <TableBody className="scrollTable">
                      {Showval
                        ? favPlayersShootingDrillDataselected
                            .slice()
                            .sort(
                              getComparator(
                                shootingDrillsOrder,
                                shootingDrillsOrderBy
                              )
                            )
                            .map((val, index) => {
                              return (
                                <TableRow className="scrollTable">
                                  <TableCell
                                    className={`${classes.stickyColumn} ${classes.cellValue}`}
                                  >
                                    <Box display="flex">
                                      {val.headshotURL &&
                                      val.headshotURL !== "" ? (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          src={
                                            val.headshotURL
                                              ? baseUrl(val.headshotURL)
                                              : ""
                                          }
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(
                                              val.playerID,
                                              val.playerName
                                            )
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      ) : (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(
                                              val.playerID,
                                              val.playerName
                                            )
                                          }
                                        >
                                          <Typography variant="caption">
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      )}
                                      &nbsp;&nbsp;
                                      <Typography
                                        variant="body2"
                                        className={classes.playerNameStyle}
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        {`${val.playerName}  ${
                                          val.trevisoText || ""
                                        }`}
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                  {/* <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.position ? val.position : "-"}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.collegeOrClub
                                        ? val.collegeOrClub
                                        : "-"}
                                    </Box>
                                  </TableCell> */}
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeSpotup}/{val.maxCountSoptUp}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeSideMidSide}/
                                      {val.maxCountSideMidSide}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeMidSideMid}/
                                      {val.maxCountMidSideMid}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeOffTheDribble}/
                                      {val.maxCountOffTheDribble}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeFreeThrows}/
                                      {val.maxCountFreeThrows}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMade3PointStar}/
                                      {val.maxCount3PointStar}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeMidRangeStar}/
                                      {val.maxCountMidRangeStar}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })
                        : favPlayersShootingDrillData
                            .slice()
                            .sort(
                              getComparator(
                                shootingDrillsOrder,
                                shootingDrillsOrderBy
                              )
                            )
                            .map((val, index) => {
                              return (
                                <TableRow className="scrollTable">
                                  <TableCell
                                    className={classes.stickyColumn}
                                    sx={{ padding: "4px", fontSize: "12px" }}
                                  >
                                    <Box display="flex">
                                      {val.headshotURL &&
                                      val.headshotURL !== "" ? (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          src={
                                            val.headshotURL
                                              ? baseUrl(val.headshotURL)
                                              : ""
                                          }
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(
                                              val.playerID,
                                              val.playerName
                                            )
                                          }
                                        >
                                          <Typography
                                            variant="caption"
                                            sx={{ fontSize: "12px" }}
                                          >
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      ) : (
                                        <Avatar
                                          className={classes.smBlue}
                                          sx={{
                                            bgcolor: "#1d428a",
                                            cursor: "pointer",
                                          }}
                                          alt="basketball"
                                          title="View Player Profile"
                                          onClick={() =>
                                            viewPlayerProfile(
                                              val.playerID,
                                              val.playerName
                                            )
                                          }
                                        >
                                          <Typography
                                            variant="caption"
                                            sx={{ fontSize: "12px" }}
                                          >
                                            {Helper.GetNameInitials(
                                              `${val.playerName}`
                                            )}
                                          </Typography>
                                        </Avatar>
                                      )}
                                      &nbsp;&nbsp;
                                      <Typography
                                        variant="body2"
                                        className={classes.playerNameStyle}
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(
                                            val.playerID,
                                            val.playerName
                                          )
                                        }
                                      >
                                        {`${val.playerName}  ${
                                          val.trevisoText || ""
                                        }`}
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                  {/* <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.position ? val.position : "-"}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.collegeOrClub
                                        ? val.collegeOrClub
                                        : "-"}
                                    </Box>
                                  </TableCell> */}
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeSpotup}/{val.maxCountSoptUp}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeSideMidSide}/
                                      {val.maxCountSideMidSide}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeMidSideMid}/
                                      {val.maxCountMidSideMid}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeOffTheDribble}/
                                      {val.maxCountOffTheDribble}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeFreeThrows}/
                                      {val.maxCountFreeThrows}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMade3PointStar}/
                                      {val.maxCount3PointStar}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={classes.cellValue}>
                                    <Box display="flex">
                                      {val.noOfMadeMidRangeStar}/
                                      {val.maxCountMidRangeStar}
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                    </TableBody>
                  </Table>
                )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>

      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Shooting Drills
              </Typography>
            </Box>
            <Box display="flex" pl={2}>
              {notes &&
                notes.length > 0 &&
                notes.find(
                  (x) =>
                    x.childName.replace(/\s/g, "").toLowerCase() ===
                    "Shooting".toLocaleLowerCase()
                ).isActive && (
                  <>
                    {/* <InfoOutlinedIcon style={{ color: "#fff" }} /> */}
                    <Typography
                      // className="subtitle2"
                      className={classes.headerTextInfo}
                    >
                      {
                        notes.find(
                          (x) =>
                            x.childName.replace(/\s/g, "").toLowerCase() ===
                            "Shooting".toLocaleLowerCase()
                        ).description
                      }
                    </Typography>
                  </>
                )}
            </Box>
          </Box>
          {loading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          )}
          <Grid container spacing={2} pt={2}>
            <DashboardCard
              title="Spot Up"
              data={spotUp}
              value="301"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Side Mid Side"
              data={sideMidSide}
              value="302"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Mid Side Mid"
              data={midSideMid}
              value="307"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Off The Dribble"
              data={offTheDribble}
              value="303"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Free Throws"
              data={freeThrows}
              value="304"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="3-Point Star"
              data={point3Star}
              value="305"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />

            <DashboardCard
              title="Mid Range Star"
              data={midRangeStar}
              value="306"
              from="CombineResults"
              tab={2}
              eventId={eventId}
              isWebView={isWebView}
            />
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
